import { render, staticRenderFns } from "./VendorStatus.vue?vue&type=template&id=551b7d40&scoped=true&"
import script from "./VendorStatus.vue?vue&type=script&lang=js&"
export * from "./VendorStatus.vue?vue&type=script&lang=js&"
import style0 from "./VendorStatus.vue?vue&type=style&index=0&id=551b7d40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b7d40",
  null
  
)

export default component.exports